import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const isAuthenticated = (window as any).DJANGO_CONFIG?.user?.isAuthenticated;

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="text-center max-w-md">
        {/* Tooth illustration */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-32 h-32 rounded-full bg-primary/10 mb-4">
            <svg className="w-16 h-16 text-primary" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M32 8C24 8 18 14 16 22C14 30 12 42 16 50C18 54 20 56 24 56C28 56 28 46 32 46C36 46 36 56 40 56C44 56 46 54 48 50C52 42 50 30 48 22C46 14 40 8 32 8Z" 
                fill="currentColor" opacity="0.2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              {/* X eyes on tooth */}
              <path d="M24 24L28 28M28 24L24 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M36 24L40 28M40 24L36 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M26 36C28 38 36 38 38 36" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
        </div>

        <h1 className="text-7xl font-bold text-primary mb-2">404</h1>
        <h2 className="text-2xl font-semibold text-foreground mb-3">Page introuvable</h2>
        <p className="text-muted-foreground mb-8">
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(isAuthenticated ? '/dashboard' : '/')}
            className="btn-primary px-6 py-2.5"
          >
            {isAuthenticated ? 'Retour au tableau de bord' : 'Retour à l\'accueil'}
          </button>
          <button
            onClick={() => navigate(-1)}
            className="btn-secondary px-6 py-2.5"
          >
            Page précédente
          </button>
        </div>
      </div>
    </div>
  );
}
